import React, { useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { EncoderObject } from '../Types/AllTypes';
import { TabView, TabPanel } from 'primereact/tabview';

type Props = {
  encodedText: string;
  entropy: number;
  size: number;
  speed: number;
  selectedAlgorithm: EncoderObject;
  encodedBytes: number[];
  humanReadableVersion: string;
}

const ResultStep = ({ encodedText, entropy, size, speed, selectedAlgorithm, encodedBytes, humanReadableVersion }: Props) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div className='resultStep'>
      {selectedAlgorithm &&
        (
          <>
            <h3>{selectedAlgorithm.name}</h3>
            <i className="pi pi-sort-down" style={{ fontSize: '2rem', paddingBottom: '1rem' }}></i>
            <div className='resultStepTextBox'>

              <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Human Readable">
                  <span className="inputTextContainer">
                    <InputTextarea id="inputtext" value={humanReadableVersion}
                      rows={5} />
                  </span>
                </TabPanel>
                <TabPanel header="Byte">
                  <span className="inputTextContainer">
                    <InputTextarea id="inputtext" value={encodedBytes.map(byte => byte.toString(16).padStart(2, '0')).join(" ")}
                      rows={5} />
                  </span>
                </TabPanel>
              </TabView>
            </div>
            <div className='resultMetadata'>
              <p>Entropy: {entropy}</p>
              <p>Size: {size}</p>
              <p>Speed: {parseFloat(speed.toString()).toFixed(2)} ms</p>
            </div>
          </>
        )
      }
    </div>
  )
}

export default ResultStep